import { faro } from "@grafana/faro-web-sdk";

/**
 * Faro measurement type shared by every app timing. The SLO recording rules in
 * Grafana Cloud select a timing by this type and its value field, so renaming
 * either breaks them.
 */
export const FARO_TIMING_TYPE = "reporting_timing";

/**
 * Creates a performance measure and sends its duration to Grafana Faro.
 *
 * Faro's API is a no-op until `initializeGrafanaFaro` has run.
 */
export function measure(
  name: string,
  startOrOptions: string | PerformanceMeasureOptions
) {
  const measurement = window.performance.measure(name, startOrOptions);

  faro.api.pushMeasurement(
    {
      type: FARO_TIMING_TYPE,
      // Loki label names cannot contain `-`, and the SLO rules match the raw
      // `<field>=` text before parsing, so the field is sent in snake_case.
      values: { [name.replace(/\W/g, "_")]: measurement.duration },
    },
    // Faro drops a measurement equal to the previous one by default, but two
    // loads that take the same time are still two loads.
    { skipDedupe: true }
  );

  return measurement;
}
